import { EpochEnum } from '@acme/api/admin';

export type ApplicationListTabConfig = {
  key: string;
  title: string;
  epochId: number | null;
};

export const adminApplicationListTabs: ApplicationListTabConfig[] = [
  { key: 'all', title: 'Все', epochId: null as number | null },
  { key: 'drafts', title: 'Черновики', epochId: EpochEnum.Draft },
  {
    key: 'changes',
    title: 'Требуются изменения',
    epochId: EpochEnum.ChangesRequired,
  },
  {
    key: 'reviewAdmin',
    title: 'На проверке УО',
    epochId: EpochEnum.ReviewAdmin,
  },
  {
    key: 'confirmedAdmin',
    title: 'Подтверждена УО',
    epochId: EpochEnum.ConfirmedAdmin,
  },
  { key: 'confirmed', title: 'Подтверждена', epochId: EpochEnum.Confirmed },
  { key: 'inProgress', title: 'Исполняется', epochId: EpochEnum.InProgress },
];
